// IFRS 18 and Cash Flow Fixes Card V2 · item A8: Audit Trail labels of the management-defined performance measures
// (mpm_routes.py) and their refusal codes, EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their
// own file).
export const I18N_IFRS18_MPM = {
  en: {
    w13: {
      action: {
        mpm_measure_created: "Performance measure added",
        mpm_measure_updated: "Performance measure edited",
        mpm_measure_deleted: "Performance measure deleted",
      },
      entity: { mpm_measure: "Management-defined performance measure" },
    },
    errors: {
      MPM_FIELDS_REQUIRED: "Enter the measure's name, description, start subtotal and at least one reconciling item.",
      MPM_SUBTOTAL_INVALID: "Pick a start subtotal shown on this engagement's profit or loss statement.",
      MPM_ITEM_INVALID: "A reconciling item is not an FS line or note code of this engagement's statements.",
      MPM_TAX_RATE_INVALID: "Enter the tax rate as a percentage from 0 to 100.",
      MPM_TAX_AMOUNT_REQUIRED: "Enter the tax effect amount, or choose a rate.",
      MPM_NOT_FOUND: "Measure not found.",
    },
  },
  ar: {
    w13: {
      action: {
        mpm_measure_created: "إضافة مقياس أداء",
        mpm_measure_updated: "تعديل مقياس أداء",
        mpm_measure_deleted: "حذف مقياس أداء",
      },
      entity: { mpm_measure: "مقياس أداء محدد من الإدارة" },
    },
    errors: {
      MPM_FIELDS_REQUIRED: "أدخل اسم المقياس ووصفه والمجموع الفرعي الذي يبدأ منه وبندًا تسوويًا واحدًا على الأقل.",
      MPM_SUBTOTAL_INVALID: "اختر مجموعًا فرعيًا ظاهرًا في قائمة الربح أو الخسارة لهذا الارتباط.",
      MPM_ITEM_INVALID: "أحد البنود التسووية ليس بندًا في القوائم المالية أو رمز إيضاح لهذا الارتباط.",
      MPM_TAX_RATE_INVALID: "أدخل نسبة الضريبة كنسبة مئوية من 0 إلى 100.",
      MPM_TAX_AMOUNT_REQUIRED: "أدخل مبلغ أثر الضريبة، أو اختر نسبة.",
      MPM_NOT_FOUND: "المقياس غير موجود.",
    },
  },
};

export default I18N_IFRS18_MPM;
